import { Box } from '@mui/material';
import { fCurrency } from '../../utils/formatNumber';
import { renderColorBox } from '../../utils/cssStyles';
import { fMonthDayYear, fMonthDayTimeYearEST } from '../../utils/formatTime';

const description = {
  field: 'description',
  headerName: 'Description',
  width: 300,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        fontSize: '0.7rem',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};
const subcategory = {
  field: 'agoraSubcategory',
  headerName: 'Subcategory',
  width: 150,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),

  type: 'customSelect',
};
const category = {
  field: 'agoraCategory',
  headerName: 'Category',
  width: 120,
  type: 'customSelect',
  renderCell: (params) => renderColorBox(params.row.agoraCategory, 'secondary'),
};
const changedFields = {
  field: 'changedFields',
  headerName: 'Changes',
  width: 120,
  type: 'customSelect',
  valueGetter: (params) => {
    if(!params.row.changedFields) return '';
    return params.row.changedFields.join(", ");
  },
  customFilterOperators: ['hasAnyOf', 'containsAnySubstring'],
  getFilterValues: (row) => (row.changedFields ?? []).filter(v => v),
};
const price = {
  field: 'price',
  headerName: 'Price',
  width: 120,
  renderCell: (params) => fCurrency(params.row.price),
  valueGetter: (params) => params.row.price,
  type: 'number',
  headerAlign: 'left',
  align: 'left',
};

const vendorName = {
  field: 'vendorName',
  headerName: 'Vendor',
  width: 180,
  type: 'customSelect',
};
const addedBy = {
  field: 'addedBy',
  headerName: 'Added By',
  width: 180,
  type: 'customSelect',
};

const id = {
  field: 'productId',
  headerName: 'PS ID',
  width: 100,
  renderCell: (params) => `PS${params.row.productId}`,
  valueGetter: (params) => `PS${params.row.productId}`,
  getFilterValues: (row) => [`PS${row.productId}`],
  type: 'customSelect',
};
const attachedItemIds = {
  field: 'attachedItemIds',
  headerName: 'Vendor Ids',
  width: 150,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
  customFilterOperators: ['hasAnyOf', 'containsAnySubstring'],
  getFilterValues: (row) => row.attachedItemIds?.split(", ") || [],
  valueGetter: (params) => params.row.attachedItemIds,
};
const vendorItemId = {
  field: 'vendorItemId',
  headerName: 'Vendor Item Id',
  width: 150,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};
const manufacturer = {
  field: 'manufacturer',
  headerName: 'Manufacturer',
  width: 200,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};

const itemId = {
  field: 'itemId',
  headerName: 'Id',
  width: 80,
  type: 'customSelect',
};

const vendorCategory = {
  field: 'category',
  headerName: 'Vendor Category',
  width: 180,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),

  type: 'customSelect',
};
const manufacturerId = {
  field: 'manufacturerId',
  headerName: 'Manufacturer Id',
  width: 180,
  type: 'customSelect',
};

const uom = {
  field: 'uom',
  headerName: 'UOM',
  valueGetter: (params) => `${params.row.uomAmount ? params.row.uomAmount : ''}${params.row.uomType ? '/' : ''}${params.row.uomType ? params.row.uomType : ''}`,
  renderCell: (params) => params.value,
  getFilterValues: (row) => [`${row.uomAmount ? row.uomAmount : ''}${row.uomType ? '/' : ''}${row.uomType ? row.uomType : ''}`,],
  width: 100,
  type: 'customSelect',
};
const baseUOMAmount = {
  field: 'baseUOMAmount',
  headerName: 'Base UOM',
  valueGetter: (params) =>
    `${params.row.baseUOMAmount ? params.row.baseUOMAmount : ''}${params.row.baseUOMType ? '/' : ''}${
      params.row.baseUOMType ? params.row.baseUOMType : ''
    }`,
  getFilterValues: (row) =>
    [`${row.baseUOMAmount ? row.baseUOMAmount : ''}${row.baseUOMType ? '/' : ''}${
      row.baseUOMType ? row.baseUOMType : ''
    }`],
  renderCell: (params) => params.value,

  width: 180,
  type: 'customSelect',
};

const isPPD = {
  field: 'isPPD',
  headerName: 'PPD',
  renderCell: (params) => params.value,
  valueGetter: (params) =>  params.value ? 'Yes' : '',
  getFilterValues: (row) => [(row.isPPD ? 'Yes' : '')].filter(v => v),
  width: 80,
  type: 'customSelect',
};

const dateAdded = {
  field: 'dateAdded',
  headerName: 'Date Added',
  type: 'customDate',
  width: 150,
  renderCell: (params) => fMonthDayYear(params.value),
  valueGetter: (params) => new Date(params.value),
};
const dateModified = {
  field: 'logTimeStamp',
  headerName: 'Date Modified',
  type: 'customDate',
  width: 150,
  renderCell: (params) => fMonthDayTimeYearEST(params.value),
  valueGetter: (params) => new Date(params.value),
};
const modifiedBy = {
  field: 'modifiedBy',
  headerName: 'Modified By',
  width: 200,
  type: 'customSelect',
};

const deleteFlag = {
  field: 'deleteFlag',
  headerName: 'Deleted',
  width: 100,
  type: 'customSelect',
  renderCell: (params) => params.value,
  valueGetter: (params) => (params.value ? 'Yes' : ''),
  getFilterValues: (row) => [(row.deleteFlag ? 'Yes' : '')].filter(v => v),
};

const ITEM_HISTORY = [
  itemId,
  description,
  changedFields,
  category,
  subcategory,
  vendorCategory,
  id,
  price,
  attachedItemIds,
  vendorItemId,
  manufacturer,
  manufacturerId,
  uom,
  baseUOMAmount,
  vendorName,
  isPPD,
  dateAdded,
  addedBy,
  dateModified,
  modifiedBy,
  deleteFlag,
];

export { ITEM_HISTORY };
